<template>
<div class="chapter">
<div class="inner_page">
<p class="image-d"><a id="page_v"><img alt="Image" src="images/bull.jpg"/></a></p><a id="page_v">
<p class="ded1">To my mentor and friend Robert W. Sparks, whose store of courtroom stories is surpassed only by the number of juries he has persuaded to go along with him; to my friends in the Johnson &amp; Johnson Law Department who bear not even a smidgen of resemblance to the characters in this book; to Francisca, who knows why; and mostly, of course, to Sheila, Olivia, and Annabel, the sum of my good fortune.</p>
<p class="ded1">A good lawyer would tell me I need to say that any similarity between characters in this novel and actual people living or dead is entirely coincidental. All right.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Dedication.vue?3b454c67